import { Table, Text } from '@mantine/core';
import { type Shema } from '../api/odjemalec';
import { denar, odstotek } from '../oblika/oblika';
import { Kartica } from '../postavitev/Podatki';
import { PomocIkona } from '../pomoc/PomocIkona';

type Rvc = Shema['RvcVozila'];

/**
 * Razlika v ceni (RVC) in DDV od nje pri prodaji vozila po posebni ureditvi – samo za podjetje, na računu se ne
 * izpiše. Vse vrednosti izračuna strežnik (enako kot poročila); {@code naslov} za podrobnosti vozila (»ob prodaji«).
 */
export function RazlikaVCeni({ rvc, naslov = 'Razlika v ceni (RVC)' }: { rvc: Rvc[]; naslov?: string }) {
  if (rvc.length === 0) {
    return null;
  }
  const vec = rvc.length > 1;
  return (
    <Kartica naslov={naslov} dejanja={<PomocIkona clanek="razlika-v-ceni" />}>
      <Table.ScrollContainer minWidth={560}>
        <Table className="stevilke" verticalSpacing={6}>
          <Table.Thead>
            <Table.Tr>
              {vec && <Table.Th>Vozilo</Table.Th>}
              <Table.Th ta="right">Prodajna cena</Table.Th>
              <Table.Th ta="right">Nabavna cena</Table.Th>
              <Table.Th ta="right">RVC</Table.Th>
              <Table.Th ta="right">Osnova za DDV</Table.Th>
              <Table.Th ta="right">DDV od RVC</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {rvc.map((r) => (
              <Table.Tr key={r.voziloId}>
                {vec && <Table.Td>{r.opis}</Table.Td>}
                <Table.Td ta="right" className="brez-preloma">
                  {denar(r.prodajnaCena)} €
                </Table.Td>
                {r.nabavnaCena == null ? (
                  <Table.Td colSpan={4} ta="right" c="dimmed">
                    Nabavna cena ni vnesena.
                  </Table.Td>
                ) : (
                  <>
                    <Table.Td ta="right" className="brez-preloma">
                      {denar(r.nabavnaCena)} €
                    </Table.Td>
                    <Table.Td ta="right" className="brez-preloma">
                      {denar(r.rvc)} € ({odstotek(r.rvcOdstotek ?? 0)} %)
                    </Table.Td>
                    <Table.Td ta="right" className="brez-preloma">
                      {denar(r.osnovaZaDdv)} €
                    </Table.Td>
                    <Table.Td ta="right" className="brez-preloma" fw={700}>
                      {denar(r.ddv)} €
                    </Table.Td>
                  </>
                )}
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      </Table.ScrollContainer>
      <Text size="xs" c="dimmed" mt="xs">
        Samo za vas, na računu se ne izpiše. RVC = prodajna − nabavna cena (nakup in neto stroški); DDV po stopnji{' '}
        {odstotek(rvc[0]!.stopnjaDdv ?? 22)} % je vključen v RVC, pri negativni RVC ga ni.
      </Text>
    </Kartica>
  );
}
